(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-phone', {
            parent: 'entity',
            /*
            url: '/employee-phone?page&sort&search',
            */
            url: '/employee-phone?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.employeePhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-phone/employee-phones.html',
                    controller: 'EmployeePhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'number,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeePhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('employee-phone-detail', {
            parent: 'employee-phone',
            url: '/employee-phone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.employeePhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-phone/employee-phone-detail.html',
                    controller: 'EmployeePhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeePhone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EmployeePhone', function($stateParams, EmployeePhone) {
                    return EmployeePhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'employee-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('employee-phone-detail.edit', {
            parent: 'employee-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-dialog.html',
                    controller: 'EmployeePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmployeePhone', function(EmployeePhone) {
                            return EmployeePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee-phone.new', {
            parent: 'employee-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-dialog.html',
                    controller: 'EmployeePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                bindingTime: null,
                                unbindingTime: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('employee-phone', null, { reload: 'employee-phone' });
                }, function() {
                    $state.go('employee-phone');
                });
            }]
        })
        .state('employee-phone.edit', {
            parent: 'employee-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-dialog.html',
                    controller: 'EmployeePhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmployeePhone', function(EmployeePhone) {
                            return EmployeePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-phone', null, { reload: 'employee-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee-phone.delete', {
            parent: 'employee-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-phone/employee-phone-delete-dialog.html',
                    controller: 'EmployeePhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EmployeePhone', function(EmployeePhone) {
                            return EmployeePhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-phone', null, { reload: 'employee-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
